module.exports = __webpack_public_path__ + "img/MW.43ff7ada.svg";